import { useEffect,useState } from 'react';

interface TimeLeft {
  hours: number;
  minutes: number;
  seconds: number;
}

export const useTimer = (dateEnd: string | null) => {
  const [timeLeft, setTimeLeft] = useState<TimeLeft>({ hours: 0, minutes: 0, seconds: 0 });

  const getRemainingTime = (endDate: string): TimeLeft => {
    const dateEndTime = new Date(endDate).getTime();
    const currentTime = Date.now();
    const remainingTime = dateEndTime - currentTime;

    const totalSeconds = Math.max(Math.floor(remainingTime / 1000), 0);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    return { hours, minutes, seconds };
  };

  useEffect(() => {
    if (!dateEnd) return;

    const updateTimer = () => {
      setTimeLeft(getRemainingTime(dateEnd));
    };

    updateTimer();
    const timerId = setInterval(updateTimer, 1000);
    
    return () => clearInterval(timerId);
  }, [dateEnd]);

  const formattedTime = {
    hours: String(timeLeft.hours).padStart(2, '0'),
    minutes: String(timeLeft.minutes).padStart(2, '0'),
    seconds: String(timeLeft.seconds).padStart(2, '0')
  };

  return formattedTime;
};